<template>
    <div id="section1">
        <div id="sec1-text">
            <h3>The Manage</h3>
            <h2>Elevating Your Supply Chain with</h2>
           <div class="box">
            <ul>
                <li class="item-1">Customized Solutions</li>
                <li class="item-2">Blockchain Excellence</li>
                <li class="item-3">Sustainable Innovation</li>
              </ul> 
           </div>
            <p>Tailoring blockchain solutions for your unique supply chain challenges, we will collaborate with you, ensuring your supply chain is meticulously crafted to meet your specific needs.</p>
            <div id="sec1-btn" @click="redirect">Get in Touch</div>
        </div>
        <div id="sec1-video">
            <video autoplay muted loop id="video-bg">
                <source :src="require('../../assets/video/cube-bg.mp4')" type="video/mp4" id="video-source"/>
            </video>
        </div>
    </div>
</template>

<script>
import {ref,computed,onMounted} from 'vue';
import {useRouter} from 'vue-router'
export default {
    setup() {
        const index = ref(0)
        const Index = computed(()=>{
            return index.value;
        })
        const router = useRouter()
        function rotate(){
            if(index.value==2){index.value=0}
            else index.value = index.value +1
            setTimeout(()=>{
                rotate()
            },3000)
        }
        function redirect(){
            router.push({name:'contactPage'})
        }
        onMounted(()=>{
            setTimeout(()=>{
                rotate()
            },3000)
        })
        
        return{
            Index,
            redirect
        }
    },
}
</script>
<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Inter&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Anek+Latin:wght@700&display=swap');
@media only screen and (max-width:480px){
      *{
        overflow-x:hidden
    }
    #section1{
      width:100vw;
      display: flex;
      flex-direction: row;
      justify-content:center;
      margin-top:3.5vh;
      padding-left:15vw;
      overflow: hidden;
    }
    #sec1-text{
        width: 85vw;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }
    #sec1-text h2{
        color: #FFF;
text-align: center;
        font-family: Anek Latin;
        font-size: 20px;
        font-style: normal;
        font-weight: 600;
        line-height: 156.6%; /* 31.32px */
        letter-spacing: 0.8px;
margin-bottom:0;
margin-top:0vh;
    }
    #sec1-text h3{
        text-align: center;
        font-family: Anek Latin;
        font-size: 34px;
        font-style: normal;
        font-weight: 700;
        line-height: 156.6%; /* 40.716px */
        letter-spacing: 1.04px;
margin-top:0px;
background-image: linear-gradient(80deg, #4749E7 44.38%, #FFF 100.59%);
-webkit-background-clip: text;
background-clip: text;
color: transparent;
margin-bottom:0.75vh;
    }
    ul li{
        color: #FFF;

        text-align: center;
        font-family: Anek Latin;
        font-size: 20px;
        font-style: normal;
        font-weight: 500;
        line-height: 156.6%; /* 31.562px */
        letter-spacing: 0.806px;
margin-bottom:0;
    }
    .box {
        height: 18px;
        overflow: hidden;
        position: relative;
        margin-top:1.5vh;
      }
    ul li{
        color: #FFF;
text-align: center;
font-family: Anek Latin;
font-size: 18px;
font-style: normal;
font-weight: 500;
line-height: 156.6%; /* 87.098px */
letter-spacing: 2.225px;
margin-bottom:0;
    }
    ul {
        float: right;
        margin: 0;
        padding: 0;
        transition: all 0.5s ease-in-out;
        -webkit-animation: scrollUp 3s ease-in-out infinite normal;
                animation: scrollUp 3s ease-in-out infinite normal;
                
      }
      
      @-webkit-keyframes scrollUp {
        from {
          -webkit-transform: translateY(0);
                  transform: translateY(0);
        }
        to {
          -webkit-transform: translateY(-80%);
                  transform: translateY(-80%);
        }
      }
      
      @keyframes scrollUp {
        from {
          -webkit-transform: translateY(0);
                  transform: translateY(0);
        }
        to {
          -webkit-transform: translateY(-80%);
                  transform: translateY(-80%);
        }
      }
    #sec1-text p{
        color: #FDFDFD;

        text-align: center;
        font-family: Inter;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 25px; /* 178.571% */
        text-transform: capitalize;
width:85vw;
margin-top:2.5vh;
    }
    #sec1-btn{
width:50vw;
height:7vh;
display:flex;
align-items: center;
justify-content: center;
border-radius: 10.172px;
background: linear-gradient(180deg, #2513B7 0%, #4A48F3 122.73%);
box-shadow: 1.56494px 1.56494px 7.82468px 0px rgba(0, 0, 0, 0.15);
color: #FFF;

text-align: center;
font-family: Inter;
font-size: 14px;
font-style: normal;
font-weight: 700;
line-height: 13.27px; /* 132.697% */
letter-spacing: 0.9px;
margin-top:2vh;
cursor: pointer;
    }
    #sec1-video{
    width:40vw;
    height:80vh;
    overflow:hidden;
    margin-top:-15vh;
    }
    #video-bg{
        width: 60vw;
        height: 80vh;
        z-index: -1;
        overflow:hidden;
    }
    #video-source{
        width: 60vw;
        height: 80vh;
    }
}
@media only screen and (min-width:481px) and (max-width:960px){
    *{
        overflow-x:hidden
    }
    #section1{
      width:100vw;
      display: flex;
      flex-direction: row;
      justify-content:center;
      margin-top:3.5vh;
      padding-left:20vw;
      overflow: hidden;
    }
    #sec1-text{
        width: 55vw;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }
    #sec1-text h2{
color: #FFF;
text-align: center;
font-family: Anek Latin;
font-size: 35.618px;
font-style: normal;
font-weight: bolder;
line-height: 156.6%; /* 87.098px */
letter-spacing: 2.225px;
margin-bottom:0;
margin-top:1vh;
    }
    #sec1-text h3{
text-align: center;
font-family: Anek Latin;
font-size: 43px;
font-style: normal;
font-weight: 800;
line-height: 156.6%; /* 87.098px */
letter-spacing: 2.225px;
margin-top:0px;
background-image: linear-gradient(80deg, #4749E7 44.38%, #FFF 100.59%);
-webkit-background-clip: text;
background-clip: text;
color: transparent;
margin-bottom:0
    }
    ul li{
        color: #FFF;
text-align: center;
font-family: Anek Latin;
font-size: 35.618px;
font-style: normal;
font-weight: bolder;
line-height: 156.6%; /* 87.098px */
letter-spacing: 2.225px;
margin-bottom:0;
margin-top:0.75vh;
    }
    .box {
        height: 45px;
        overflow: hidden;
        position: relative;
        margin-top:1.5vh;
      }
    ul li{
        color: #FFF;
text-align: center;
font-family: Anek Latin;
font-size: 33px;
font-style: normal;
font-weight: 500;
line-height: 156.6%; /* 87.098px */
letter-spacing: 2.225px;
margin-bottom:0;
    }
    ul {
        float: right;
        margin: 0;
        padding: 0;
        transition: all 0.5s ease-in-out;
        -webkit-animation: scrollUp 3s ease-in-out infinite normal;
                animation: scrollUp 3s ease-in-out infinite normal;
                
      }
      
      @-webkit-keyframes scrollUp {
        from {
          -webkit-transform: translateY(0);
                  transform: translateY(0);
        }
        to {
          -webkit-transform: translateY(-80%);
                  transform: translateY(-80%);
        }
      }
      
      @keyframes scrollUp {
        from {
          -webkit-transform: translateY(0);
                  transform: translateY(0);
        }
        to {
          -webkit-transform: translateY(-80%);
                  transform: translateY(-80%);
        }
      }
    #sec1-text p{
color: #FDFDFD;
text-align: center;
font-family: Inter;
font-size: 18.069px;
font-style: normal;
font-weight: 400;
line-height: 34.603px; /* 150% */
text-transform: capitalize;
width:55vw;
margin-top:2vh;
    }
    #sec1-btn{
width: 198.747px;
height: 60.25px;
display:flex;
align-items: center;
justify-content: center;
border-radius: 10.172px;
background: linear-gradient(180deg, #2513B7 0%, #4A48F3 122.73%);
box-shadow: 1.56494px 1.56494px 7.82468px 0px rgba(0, 0, 0, 0.15);
color: #FFF;
text-align: center;
font-family: Inter;
font-size: 16.432px;
font-style: normal;
font-weight: 700;
line-height: 24.648px; /* 150% */
letter-spacing: 1.479px;
margin-top:2vh;
cursor: pointer;
    }
    #sec1-video{
    width:40vw;
    height:20vh;
    overflow:hidden;
    }
    #video-bg{
        width: 40vw;
        height: 20vh;
        z-index: -1;
        overflow:hidden;
    }
    #video-source{
        width: 40vw;
        height: 60%;
    }
}
@media only screen and (min-width:961px){
    *{
        overflow-x:hidden
    }
    #section1{
      width:100vw;
      display: flex;
      flex-direction: row;
      justify-content:center;
      margin-top:9.5vh;
      padding-left:20vw;
      overflow: hidden;
    }
    #sec1-text{
        width: 55vw;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }
    #sec1-text h2{
color: #FFF;
text-align: center;
font-family: Anek Latin;
font-size: 33px;
font-style: normal;
font-weight:500;
line-height: 156.6%; /* 87.098px */
letter-spacing: 2.225px;
margin-bottom:0;
margin-top:1.75vh;
    }
    #sec1-text h3{
        font-family: 'Anek Latin', sans-serif;
font-size: 45px;
font-style: normal;
font-weight: bolder;
line-height: 156.6%; /* 87.098px */
letter-spacing: 2.225px;
margin-top:0px;
background-image: linear-gradient(80deg, #4749E7 44.38%, #FFF 100.59%);
-webkit-background-clip: text;
background-clip: text;
color: transparent;
margin-bottom:0
    }
    .box {
        height: 40px;
        overflow: hidden;
        position: relative;
        margin-top:3.5vh;
      }
    ul li{
        color: #FFF;
text-align: center;
font-family: Anek Latin;
font-size: 33px;
font-style: normal;
font-weight: 500;
line-height: 156.6%; /* 87.098px */
letter-spacing: 2.225px;
margin-bottom:0;
    }
    ul {
        float: right;
        margin: 0;
        padding: 0;
        transition: all 0.5s ease-in-out;
        -webkit-animation: scrollUp 3s ease-in-out infinite normal;
                animation: scrollUp 3s ease-in-out infinite normal;
                
      }
      
      @-webkit-keyframes scrollUp {
        from {
          -webkit-transform: translateY(0);
                  transform: translateY(0);
        }
        to {
          -webkit-transform: translateY(-80%);
                  transform: translateY(-80%);
        }
      }
      
      @keyframes scrollUp {
        from {
          -webkit-transform: translateY(0);
                  transform: translateY(0);
        }
        to {
          -webkit-transform: translateY(-80%);
                  transform: translateY(-80%);
        }
      }

    #sec1-text p{
color: #FDFDFD;
text-align: center;
font-family: Inter;
font-size: 18px;
font-style: normal;
font-weight: 400;
line-height: 34.603px; /* 150% */
text-transform: capitalize;
width:53vw;
margin-top:3.5vh;
    }
    #sec1-btn{
width: 198.747px;
height: 55.25px;
display:flex;
align-items: center;
justify-content: center;
border-radius: 10.172px;
background: linear-gradient(180deg, #2513B7 0%, #4A48F3 122.73%);
box-shadow: 1.56494px 1.56494px 7.82468px 0px rgba(0, 0, 0, 0.15);
color: #FFF;
text-align: center;
font-family: Inter;
font-size: 15px;
font-style: normal;
font-weight: 600;
line-height: 24.648px; /* 150% */
letter-spacing: 1.479px;
margin-top:3vh;
cursor: pointer;
    }
    #sec1-video{
    width:40vw;
    height:60vh;
    overflow:hidden;
    }
    #video-bg{
        width: 40vw;
        height: 60vh;
        z-index: -1;
        overflow:hidden;
    }
    #video-source{
        width: 40vw;
        height: 60vh;
    }
}
</style>